import { DESKTOP_BREAKPOINT } from './tokens/breakpoints';

/**
 * MUI `sx` helper — phone + tablet get the same value, desktop gets another.
 * MUI cascades xs → sm, so setting `xs` covers both 0–599px and 600–899px.
 *
 * @example
 * sx={responsive(16, 32)}           // padding: 16 on phone/tablet, 32 on desktop
 * sx={{ gap: responsive(8, 16) }}
 */
export function responsive(mobileTablet, desktop) {
  return {
    xs: mobileTablet,
    [DESKTOP_BREAKPOINT]: desktop,
  };
}

/**
 * Three-value variant when you explicitly need the same phone+tablet value
 * but want to document intent. xs and sm are always identical by design rule.
 */
export function responsiveLayout(mobileTablet, desktop) {
  return {
    xs: mobileTablet,
    sm: mobileTablet,
    [DESKTOP_BREAKPOINT]: desktop,
  };
}

/**
 * Container horizontal padding using design tokens.
 */
export function containerPx(mobileTablet = 16, desktop = 32) {
  return responsive(mobileTablet, desktop);
}

export { DESKTOP_BREAKPOINT, MOBILE_TABLET_MAX, mediaQueries } from './tokens/breakpoints';
